import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { FormInput, FormNumber, FormSelect } from '.';
import focusInputOnError from '../helpers/focusInputOnError';
import { parseStringToNumber } from '../helpers/utils';

export function EmitContactInformationForm(props: any) {
  const {
    handleSubmit,
    previousPage,
    initialValues: { email },
  } = props;

  const [communesOptions] = useState([]);

  return (
    <div className="col-12 col-md-10 wizard-card">
      <form onSubmit={handleSubmit} noValidate={true}>
        <div className="row">
          <div className="col-12">
            <h2 className="wizard-card--title">
              Información de contacto
              <div className="progress-step">
                <div className="done" />
                <div className="current" />
                <div />
                <div />
              </div>
            </h2>
          </div>
          <div className="col-12 col-sm-6 form-group">
            <div>
              <span className="text-bold">Correo</span>
              <p>{email}</p>
            </div>
          </div>
          <div className="w-100 d-none d-sm-block" />
          <div className="col-12 col-sm-6 col-md-5 col-lg-4 form-group">
            <label htmlFor="phone">Teléfono</label>
            <Field
              name="phone"
              placeholder="941234567"
              inputFormat="#########"
              component={FormNumber}
              isPhone={true}
            />
          </div>
          <div className="w-100 d-none d-sm-block" />
          <div className="col-12 col-sm-8 form-group">
            <label htmlFor="address">Dirección</label>
            <Field
              name="address"
              component={FormInput}
              placeholder="Ej. Avenida Libertador Bernardo O’Higgins"
            />
          </div>
          <div className="w-100 d-none d-sm-block" />
          <div className="col-12 col-sm-6 col-md-4 form-group">
            <label htmlFor="addressNumber">Número</label>
            <Field
              name="addressNumber"
              placeholder="Ej. 1234"
              inputFormat="#####"
              normalize={parseStringToNumber}
              component={FormNumber}
            />
          </div>
          <div className="w-100 d-none d-sm-block" />
          <div className="col-12 col-sm-8 col-md-6 form-group">
            <label htmlFor="region">Región</label>
          </div>
          <div className="w-100 d-none d-sm-block" />
          <div className="col-12 col-sm-8 col-md-6 form-group">
            <label htmlFor="province">Provincia</label>
          </div>
          <div className="w-100 d-none d-sm-block" />
          <div className="col-12 col-sm-8 col-md-6 form-group">
            <label htmlFor="commune">Comuna</label>
            <Field
              name="commune"
              options={communesOptions}
              placeholder="Selecciona..."
              component={FormSelect}
              isDisabled={!communesOptions.length}
            />
          </div>
        </div>
        <div className="row justify-content-center mt30 buttons-container">
          <div className="col-12 col-sm-5 col-md-4">
            <button
              className="btn white back-to-client-info"
              type="button"
              onClick={previousPage}
            >
              Volver
            </button>
          </div>
          <div className="col-12 col-sm-5 col-md-4">
            <button className="btn primary go-to-dps" type="submit">
              Continuar
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default withRouter(
  reduxForm<any, any>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'proposal',
    onSubmitFail: focusInputOnError,
    // validate,
  })(EmitContactInformationForm),
);
